import api from "../api";
const login = async (account,password) => {

  const requestData={
    "account": account,
    "password": password,
  }
  try {

    const response = await api.post(process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/auth/login", requestData);

    // Check if the status code indicates success (typically 200 or 201)
    if (response.status === 200 || response.status === 201) {

      return response.data; // Optionally return the response data
    } else {
      console.error("Login failed with status:", response.status);
      return null; // Return null or handle as necessary
    }

  } catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }


}

export default login;
